import { useNavigate } from "react-router";
import { Button, Group, Select } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Logo } from "../../../shared/svg";
import "./Header.scss";
import { useTranslation } from "react-i18next";

export const TermsHeader = () => {
  const matches = useMediaQuery("(max-width: 485px)");
  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  const handleLanguageChange = (value: string | null) => {
    if (value) {
      i18n.changeLanguage(value);
    }
  };

  return (
    <Group
      justify={matches ? "center" : "space-between"}
      align="center"
      className="header"
      px="24px"
      py="16px"
    >
      <Logo width={190} height={40} />
      {!matches && (
        <Group>
          <Select
            value={i18n.language}
            onChange={handleLanguageChange}
            data={[
              { value: "en", label: t("english") },
              { value: "uk", label: t("ukrainian") },
            ]}
            style={{ width: 150 }}
          />
          <Button variant="outline" onClick={() => navigate("/login/sign-in")}>
            Log In
          </Button>
          <Button onClick={() => navigate("/auth/sign-up")}>Sing Up</Button>
        </Group>
      )}
    </Group>
  );
};
